import util   from '../../common/AppUtil';

const ServerMode = 1;
const ApiCode = "BasDossier";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  },

  importDossier:function(params) {
    return util.callServerPost(ServerMode,"BasDossierImport",params,"import");
  },

  getListPage: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"list");
  },

  removeRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"del");
  },

  addRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"add");
  },

  saveRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },

  getRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"get");
  },


  // Read call for server-paged results (Browse Bas Dossiers)
  getPagedList: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"pagedlist");
  },

}
  


// WEBPACK FOOTER //
// ./src/api/bas/dossier.js